import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { bankIFSCValidation } from "../validation/proof-details";

const IfscInput = ({
  name,
  title,
  type,
  value,
  givenError,
  handleChange,
  placeholder,
  className,
}) => {
  const [ifscCode, setIfscCode] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if(givenError) {
      setError(givenError)
    }
  }, [givenError])

  const handleChangee = (e) => {
    const value = e.target.value;
    const form = {ifscCode: value };
    const { errors, isValid } = bankIFSCValidation(form);
    setIfscCode(value);
    handleChange(e);
    setError(errors.ifscCode);
  };

  return (
    <div className="mb-2 text-start">
      {title && (
        <label className="d-flex align-items-center fs-12 mb-2 form-label">
          <span className="required">{title}</span>
        </label>
      )}
      <input
        type={type}
        className={className ? className : "form-control  form-control-solid"}
        name={name}
        placeholder={placeholder}
        value={ifscCode}
        maxLength={18}
        onChange={(e) => {
          handleChangee(e);
        }}
      />
      <span className="fs-10 text-danger">{error}</span>
    </div>
  );
};

IfscInput.prototype = {
  name: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.any,
  error: PropTypes.string,
  handleChange: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
};
export default IfscInput;
